import { type FC } from "react";
import * as styles from "./styles.css";

// 削除予定のコンポーネントです。
// デザイン上の理由がない場合、
// app/packs/shared/components/Tableディレクトリ直下のものを使用してください。

type Props = {
  /** thの内容 */
  children?: React.ReactNode;
  /** コンポーネントに適用するクラス名 */
  className?: string;
};

export const Th: FC<Props> = ({ children, className }) => (
  <th
    className={`
      ${styles.th}
      ${className || ""}
    `}
  >
    {children}
  </th>
);
